import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "line-awesome/dist/line-awesome/css/line-awesome.css";
import "rsuite/dist/rsuite.min.css";
import store, { persistor } from "./store";
import Routers from "./routes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { NotificationProvider } from "./utils/notificationProvider";
import { CountdownProvider } from "./context/CountdownContext";
import { AuthProvider } from "./context/AuthContext";

import { BrowserRouter as Router } from "react-router-dom";

// console.log = console.warn = console.error = () => {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <CountdownProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <NotificationProvider>
            <Router>
              <Routers />
            </Router>
          </NotificationProvider>
        </PersistGate>
      </Provider>
    </CountdownProvider>
  </AuthProvider>
);
